// Generates a url-friendly slug, copied and modified from https://byby.dev/js-slugify-string
export async function createSlug(str: string, _locale: string) {
  // Translations
  // const t = await getT(locale, 'shared/translations');

  const newStr = String(str)
    .replace(/&/g, 'and') // replace ampersand with the word "and" per 8MS recommendation
    .normalize('NFKD') // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // remove consecutive hyphens

  return String(newStr); // remove consecutive hyphens
}

export type Environment = 'Development' | 'QA' | 'Production';

export function getEnvironment(): Environment {
  const environment =
    process.env.GMIServer === 'Development'
      ? 'Development'
      : process.env.GMIServer === 'QA'
        ? 'QA'
        : process.env.GMIServer === 'Production'
          ? 'Production'
          : null;

  if (!environment) {
    throw new Error(
      `Invalid or not set environment: ${environment}.  Check GMIServer environment variable`
    );
  }

  return environment;
}

export async function getResponseObject<T>(
  url: string,
  bearerToken: string,
  timeoutMS?: number
): Promise<T | null> {
  try {
    const abortSignal = timeoutMS ? AbortSignal.timeout(timeoutMS) : undefined;
    abortSignal?.addEventListener('abort', () => {
      console.log(url, 'timed out after', timeoutMS, 'ms');
    });
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
      signal: abortSignal,
    });
    if (response.ok && response.headers.get('content-type')?.includes('application/json')) {
      const data = await response.json();
      return data as T;
    } else {
      if (response.status === 404) {
        return null; // expected "not found" — caller handles this
      }
      if (process.env.SKIP_DETAILED_SERVICE_LOGS === 'true') {
        console.error(`Error fetching ${url}.`, response.status, response.statusText);
      } else {
        const responseText = await response.text();
        console.error(
          `Error fetching ${url}. response text: "${responseText}"`,
          response.status,
          response.statusText
        );
      }
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
  } catch (error) {
    console.log('***Exception Catched - ', url, error);
    const errorMessage = error instanceof Error ? error.message : String(error);
    if (process.env.SKIP_DETAILED_SERVICE_LOGS === 'true') {
      console.error(`Error fetching ${url}. `);
    } else {
      console.error(`Error fetching ${url}. ${errorMessage}`);
    }
    throw error;
  }
}
